import { h, van } from "../lib/tb.js";
import * as api from "../lib/api.js";
import { Card, FormGroup } from "../lib/components.js";
import { toast } from "../lib/toast.js";

export function LoginView({ onSuccess }) {
  const error = van.state("");
  const busy = van.state(false);

  const submit = async (e) => {
    e.preventDefault();
    error.val = "";
    busy.val = true;
    const form = e.target;
    try {
      await api.login(form.user.value, form.password.value);
      onSuccess();
    } catch(err) {
      error.val = err.message;
      toast.error(err.message);
    } finally {
      busy.val = false;
    }
  };

  return h(".min-h-screen.grid.place-items-center.p-4", [
    Card({ class: "w-full max-w-sm" },
      h("form.form-stack", { onsubmit: submit }, [
        h(".card__header", [
          h("h1.card__title", "Přihlášení"),
          h("p.card__desc", "Správa salonů IDENEL"),
        ]),
        FormGroup({ label: "Uživatel" },
          (id) => h("input.input", { id, name: "user", type: "text", autocomplete: "username", required: true, autofocus: true })),
        FormGroup({ label: "Heslo" },
          (id) => h("input.input", { id, name: "password", type: "password", autocomplete: "current-password", required: true })),
        () => error.val ? h("p.text-sm.text-red-600", error.val) : null,
        h("button.btn.btn-primary.w-full", { type: "submit", disabled: busy },
          () => busy.val ? "Přihlašuji…" : "Přihlásit se"),
      ]),
    ),
  ]);
}
